import React, { useEffect, useState } from "react";
import {
  FetchAddAppoientmentVisit,
  FetchVisitReason,
  GetactiveAuth,
  GetDeliveryMode,
  GetDoctorsRequest,
  GetResource,
  Getserviceaddress,
  Postappointments,
} from "../../../../api/helper";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import moment from "moment";
import { ShowToast } from "../../../../helpers/ToastService";
import { DropDownManuCustomMulti } from "../../../Components/DropDownButton";

const validationSchema = Yup.object().shape({
  patientId: Yup.string().required("Client is required"),
  dob: Yup.string(), // DOB is auto-filled, so not required
  doctorId: Yup.string().required("Provider is required"),
  deliveryMode: Yup.string().required("Appointment type is required"),
  date: Yup.string()
    .required("Date is required")
    .test("is-future-or-today", "Date cannot be in the past", (value) => {
      if (!value) return false;
      const selected = moment(value, "YYYY-MM-DD");
      const today = moment().startOf("day");
      return selected.isSameOrAfter(today);
    }),
  startTime: Yup.string().required("Start time is required"),
  visitReason: Yup.string().required("Visit reason is required"),
  duration: Yup.number()
    .typeError("Duration must be a number")
    .required("Duration is required")
    .min(1, "Minimum duration is 1 minute"),
  appointmentStatus: Yup.string().required("Status is required"),
  appointmentResource: Yup.string().required("Resource is required"),

  serviceLocationId: Yup.string().required("Service location is required"),
  paymentSource: Yup.string(),

  patientIntake: Yup.array()
    .min(1, "At least one patient intake document is required")
    .required("Patient intake is required"),

  providerTask: Yup.array()
    .min(1, "At least one provider task must be selected")
    .required("Provider task is required"),

  // Booleans are optional unless you want to enforce selection
  "email-confirm": Yup.boolean(),
  "sms-confirm": Yup.boolean(),
  "inapp-confirm": Yup.boolean(),

  "provider-email-confirm": Yup.boolean(),
  "provider-sms-confirm": Yup.boolean(),
  "provider-inapp-confirm": Yup.boolean(),

  repeats: Yup.boolean(),

  repeatDays: Yup.array().when("repeats", {
    is: true,
    then: () =>
      Yup.array()
        .min(1, "Select at least one repeat day")
        .required("Repeat days required"),
    otherwise: () => Yup.array().notRequired(),
  }),

  endCondition: Yup.string().notRequired(),

  specificDate: Yup.string().when("endCondition", {
    is: "specific-date",
    then: () =>
      Yup.string()
        .required("Specific date is required")
        .test("valid-date", "Date is invalid", (value) => !!Date.parse(value)),
    otherwise: () => Yup.string().notRequired(),
  }),

  numberOfEvents: Yup.string().when("endCondition", {
    is: "number-of-events",
    then: () =>
      Yup.number()
        .typeError("Must be a number")
        .positive("Must be a positive number")
        .required("Number of events is required"),

    otherwise: () => Yup.mixed().notRequired(),
  }),
});
const CreateAppointment = ({ info, setShowAppointmentPanel }) => {
  const [authorization, setauthorization] = useState(null);
  const [providerdata, setproviderdata] = useState([]);
  const [visitReasondata, setvisitReasondata] = useState([]);
  const [addressData, setaddressData] = useState([]);
  const [visitstatus, setvisitstatus] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [appointmentType, setappointmentType] = useState([]);
  const [resourcedata, setresourcedata] = useState([]);
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [isEditingClientEmail, setIsEditingClientEmail] = useState(false);
  const [isEditingClientPhone, setIsEditingClientPhone] = useState(false);
  const [providerEmail, setProviderEmail] = useState("");
  const [providerPhone, setProviderPhone] = useState("");
  const [isEditingProviderEmail, setIsEditingProviderEmail] = useState(false);
  const [isEditingProviderPhone, setIsEditingProviderPhone] = useState(false);
  const [clientEmailError, setClientEmailError] = useState("");
  const [clientPhoneError, setClientPhoneError] = useState("");
  const [providerEmailError, setProviderEmailError] = useState("");
  const [providerPhoneError, setProviderPhoneError] = useState("");
  const [providertimezone, setprovidertimezone] = useState("");
  const [clienttimezone, setclienttimezone] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      patientId: "",
      dob: "",
      doctorId: "",
      deliveryMode: "",
      date: "",
      startTime: "",
      visitReason: "",
      Duration: "",
      status: "",
      repeatAppointment: "",
      appointmentResource: "",

      repeats: false,
      serviceLocationId: "",
      paymentSource: "",
      patientIntake: [],
      providerTask: [],
      patientConfirmation: {
        emailConfirmation: false,
        SMSConfirmation: false,
        pushNotification: false,
      },
      providerConfirmation: {
        emailConfirmation: false,
        SMSConfirmation: false,
        pushNotification: false,
      },
    },
  });

  const repeats = watch("repeats");
  const selectedType = watch("deliveryMode");

  const onSubmit = async (formData) => {
    console.log("Raw Form Data:", formData);

    const provider = providerdata.find((p) => p._id === formData.doctorId);
    const location = addressData.find(
      (loc) => loc._id === formData.serviceLocationId
    );
    const appointmentTypeItem = appointmentType.find(
      (type) => type._id === formData.deliveryMode
    );
    const reason = visitReasondata.find((r) => r._id === formData.visitReason);
    const repeatData =
      formData.repeats === true
        ? {
            repeatAppointment: "Yes",
            repeatDays: formData.repeatDays || [],
            endCondition: formData.endCondition,
            ...(formData.endCondition === "specific-date" && {
              specificDate: formData.specificDate,
            }),
            ...(formData.endCondition === "number-of-events" && {
              numberOfEvents: formData.numberOfEvents,
            }),
          }
        : {
            repeatAppointment: "No",
          };

    const data = {
      ...(authorization?.Auth && { authorizationDetailId: authorization._id }),
      patientRequestId: formData.patientId,
      dob: formData.dob,
      doctorRequestId: formData.doctorId,
      agencyId: profiledata?._id,
      deliveryMode: formData.deliveryMode,
      appointmentResource: formData.appointmentResource,
      date: new Date(formData.date).toISOString(),
      startTime: formData.startTime,
      visitReason: formData.visitReason,
      Duration: formData.duration ? `${formData.duration} minutes` : null,
      appointmentStatus: formData.appointmentStatus,
      serviceLocationId: formData.serviceLocationId,
      paymentSource: formData.paymentSource,
      patientIntake: formData.patientIntake || [],
      providerTask: formData.providerTask || [],
      patientConfirmation: {
        emailConfirmation: formData["email-confirm"] || false,
        SMSConfirmation: formData["sms-confirm"] || false,
        pushNotification: formData["inapp-confirm"] || false,
      },
      providerConfirmation: {
        emailConfirmation: formData["provider-email-confirm"] || false,
        SMSConfirmation: formData["provider-sms-confirm"] || false,
        pushNotification: formData["provider-inapp-confirm"] || false,
      },
         emailData: {
        clientName: info ? `${info.firstName} ${info.lastName}` : "",
        providerName: provider
          ? `${provider.firstName} ${provider.lastName}`
          : "",
        appointmentDate: new Date(formData.date).toISOString(),
        appointmentTime: formData.startTime,
        timeZone: providertimezone,
        location: location?.name || "",
        appointmentType: appointmentTypeItem?.name || "",
        visitReason: reason?.visitReason || "",
        paymentSource: formData.paymentSource || "",
        logoUrl: "https://your-domain.com/logo.png",
        telehealthLink: "https://your-telehealth-link.com",
        documentLink: "https://your-document-link.com",
        manageAppointmentLink: "https://your-manage-link.com",
        supportEmail: "support@ennhealth.com",
      },
      ...repeatData,
    };

    console.log("Mapped Data for API:", data);
    // return
    try {
      const response = await Postappointments(data);
      ShowToast(response.data.message, "success");
      setShowAppointmentPanel(false);
      reset();
      setValue("providerTask", []);
      setValue("patientIntake", []);
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const Handleselecttask = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("providerTask", ids, { shouldValidate: true });
  };
  const HandleselectpatientIntake = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("patientIntake", ids, { shouldValidate: true });
  };
  const FetchDoctorrequest = async () => {
    try {
      const response = await GetDoctorsRequest({ status: "approved" });
      setproviderdata(response?.data.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const PatientId = watch("patientId");
  const fetchAuthorizations = async () => {
    try {
      const activeauth = await GetactiveAuth(profiledata?._id, PatientId);
      setauthorization(activeauth?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchDatalist = async () => {
    try {
      const response = await GetDeliveryMode(`?id=${profiledata?._id}`);
      setappointmentType(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const GetVisitReason = async () => {
    const response = await FetchVisitReason(`?id=${profiledata?._id}`);
    setvisitReasondata(response?.data?.data);
  };
  const GetAppoientmentVisit = async () => {
    const response = await FetchAddAppoientmentVisit(`?id=${profiledata?._id}`);
    setvisitstatus(response?.data?.data);
  };
  const FetchAddresslist = async () => {
    const data = {
      id: profiledata?._id,
    };
    try {
      const response = await Getserviceaddress(data);
      setaddressData(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchResource = async () => {
    try {
      const respo = await GetResource(profiledata?._id);
      setresourcedata(respo?.data?.data?.results);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    FetchAddresslist();
    FetchDoctorrequest();
    GetAppoientmentVisit();
    GetVisitReason();
    FetchDatalist();
    FetchResource();
  }, []);
  useEffect(() => {
    if (PatientId) {
      fetchAuthorizations();
    }
  }, [PatientId]);
  const selectedVisitReasonId = watch("visitReason");
  useEffect(() => {
    if (selectedVisitReasonId) {
      const selected = visitReasondata.find(
        (item) => item._id === selectedVisitReasonId
      );
      console.log(selected, "selected=-=-=-=-");
      if (selected) {
        setValue("duration", selected.appointmentDuration);
        //  setValue("paymentSource", selected.PaymentSourcesId?.name);
      }
    }
  }, [selectedVisitReasonId, visitReasondata, setValue]);
  useEffect(() => {
    const provider = providerdata.find((p) => p._id === watch("doctorId"));
    if (provider) {
      setProviderEmail(provider?.email || "");
      setProviderPhone(provider?.phone || "");
      setprovidertimezone(provider?.TimeZone || "");
    }
  }, [watch("doctorId")]);
  const fullName = info?.patientId?.firstName + " " + info?.patientId?.lastName;
  const formatDOB = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };
  useEffect(() => {
    if (info) {
      setValue("patientId", info._id);
      setValue("dob", formatDOB(info?.DOB));
      setValue("paymentSource", info?.PaymentSourcesId?.name || "");
      setClientEmail(info?.email || "");
      setClientPhone(info?.phone || "");
      setclienttimezone(info?.TimeZone || "");
    }
  }, [info, setValue]);
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone) => {
    const regex = /^\d{10}$/;
    return regex.test(phone);
  };

  const startTime = watch("startTime");
  const selectedappointmentDate = watch("date");


  const cleanTimezone = (zone) => {
    if (!zone) return "";
    return zone.replace(/\s*\(GMT.*\)/, "");
  };

  const formatTimeInZone = (dateStr, timeStr, fromZone, toZone) => {
    if (!dateStr || !timeStr || !fromZone || !toZone) return "";

    const cleanFrom = cleanTimezone(fromZone);
    const cleanTo = cleanTimezone(toZone);

    const datetime = moment.tz(
      `${dateStr} ${timeStr}`,
      "YYYY-MM-DD HH:mm",
      cleanFrom
    );
    const converted = datetime.clone().tz(cleanTo);

    return converted.format("hh:mm A z");
  };
  const getAbbreviation = (dateStr, timeStr, zone) => {
    const cleanZone = cleanTimezone(zone);
    const dateTime = moment.tz(
      `${dateStr} ${timeStr || "12:00"}`,
      "YYYY-MM-DD HH:mm",
      cleanZone
    );
    return dateTime.format("z");
  };
  const providerAbbr = getAbbreviation(
    selectedappointmentDate,
    startTime,
    providertimezone
  );
  const clientAbbr = getAbbreviation(
    selectedappointmentDate,
    startTime,
    clienttimezone
  );
  const providerTime = formatTimeInZone(
    selectedappointmentDate,
    startTime,
    providertimezone,
    providertimezone
  );

  const clientTime = formatTimeInZone(
    selectedappointmentDate,
    startTime,
    providertimezone,
    clienttimezone
  );
  return (
    <div className="modal-content_CalendarView">
      <span
        className="close_CalendarView"
        onClick={() => setShowAppointmentPanel(false)}
      >
        &times;
      </span>
      <h2 id="modal-title">{"Add Appointment"}</h2>
      <form
        className="form-container_CalendarView"
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* Client Information Section */}
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Client Information
          </div>
          <div>
            <div className="form-group_CalendarView">
              <label htmlFor="client-select">Select Client:</label>
              <select id="client-select" {...register("patientId")} disabled>
                <option value={info?._id}>{fullName}</option>
              </select>
              {errors.patientId && (
                <p className="error">{errors.patientId.message}</p>
              )}
            </div>
            <div className="form-group_CalendarView">
              <label htmlFor="client-dob">DOB:</label>
              <input
                type="text"
                id="client-dob"
                {...register("dob")}
                defaultValue={formatDOB(info?.DOB)}
                disabled
              />
            </div>
          </div>
        </div>
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Provider Information
          </div>
          <div className="form-row_CalendarView">
            <div className="form-group_CalendarView">
              <label htmlFor="providerSelect">Select Provider:</label>
              <select id="providerSelect" {...register("doctorId")}>
                <option value="">-- Select --</option>
                {providerdata.map((provider, index) => (
                  <option key={provider._id} value={provider._id}>
                    {provider.firstName} {provider.lastName}
                  </option>
                ))}
              </select>
              {errors.doctorId && (
                <p className="error">{errors.doctorId.message}</p>
              )}
            </div>
          </div>
        </div>
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Appointment Details
          </div>
          <div className="form-row_CalendarView">
            <div className="form-group_CalendarView">
              <label htmlFor="appointment-type">Appointment Type:</label>
              <select
                id="appointment-type"
                name="type"
                // required
                {...register("deliveryMode")}
              >
                <option value="">-- Select --</option>
                {appointmentType.map((item, index) => (
                  <option key={item._id} value={item._id}>
                    {item.name}
                  </option>
                ))}
              </select>
              {errors.deliveryMode && (
                <p className="error">{errors.deliveryMode.message}</p>
              )}
            </div>
            {selectedType === "Telehealth" && (
              <div className="form-group_CalendarView">
                <label>Telehealth URL:</label>
                <a style={{ textAlign: "left" }}>Join Telehealth Session</a>
              </div>
            )}
          </div>
          <div>
            <div className="form-group_CalendarView">
              <label htmlFor="date">Date:</label>
              <input
                type="date"
                id="date"
                name="date"
                // required
                {...register("date")}
              />
              {errors.date && <p className="error">{errors.date.message}</p>}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="form-group_CalendarView">
                <label htmlFor="time">
                  Start Time (Provider Time Zone - {providerAbbr || "..."}):
                </label>
                <input
                  type="time"
                  id="time"
                  name="start"
                  // required
                  {...register("startTime")}
                />
                {errors.startTime && (
                  <p className="error">{errors.startTime.message}</p>
                )}
              </div>
              <div style={{ width: 30 }} />
              <div className="form-group_CalendarView">
                <label htmlFor="time">
                  {" "}
                  Client Time ({clientAbbr || "..."}):
                </label>
                <input
                  type="text"
                  id="clientTime"
                  value={clientTime}
                  disabled
                />
              </div>
            </div>
          </div>
          {startTime && selectedappointmentDate && (
            <div>
              This appointment will display as <strong>{providerTime}</strong>{" "}
              for the provider and <strong>{clientTime}</strong> for the client.
            </div>
          )}
          <div>
            <div className="form-group_CalendarView">
              <label htmlFor="visit-reason">Resource:</label>
              <select
                id="visit-reason"
                name="appointmentResource"
                {...register("appointmentResource")}
              >
                <option value="">-- Select Resource --</option>
                {resourcedata.map((item) => {
                  return (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
              {errors.appointmentResource && (
                <p className="error">{errors.appointmentResource.message}</p>
              )}
            </div>
          </div>
          <div>
            <div className="form-group_CalendarView">
              <label htmlFor="visit-reason">Visit Reason:</label>
              <select
                id="visit-reason"
                name="visitReason"
                {...register("visitReason")}
              >
                <option value="">-- Select Visit Reason --</option>
                {visitReasondata.map((item) => {
                  return (
                    <option key={item._id} value={item._id}>
                      {item.visitReason}
                    </option>
                  );
                })}
              </select>
              {errors.visitReason && (
                <p className="error">{errors.visitReason.message}</p>
              )}
            </div>
            <div className="form-group_CalendarView">
              <label htmlFor="duration">Duration (in mins):</label>
              <input
                type="number"
                id="duration"
                name="duration"
                {...register("duration")}
                min={1}
                disabled
                // required
              />
              {/* {errors.duration && (
                <p className="error">{errors.duration.message}</p>
              )} */}
            </div>
          </div>
          {/* New Status Field */}
          <div className="form-row_CalendarView">
            <div className="form-group_CalendarView">
              <label htmlFor="appointment-status">Status:</label>
              <select
                id="appointment-status"
                name="appointmentStatus"
                // required
                {...register("appointmentStatus")}
              >
                <option value="">-- Select Visit Reason --</option>
                {visitstatus.map((item) => {
                  return (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
              {errors.appointmentStatus && (
                <p className="error">{errors.appointmentStatus.message}</p>
              )}
            </div>
          </div>
        </div>
        {/* Repeat Appointment Section */}
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Repeat Appointment
          </div>
          <div className="form-row_CalendarView">
            <div className="form-group_CalendarView">
              <label htmlFor="repeats">Repeats:</label>
              <input
                type="checkbox"
                id="repeats"
                name="repeats"
                {...register("repeats")}
                // defaultValue={'No'}
              />
            </div>
          </div>
          {repeats && (
            <div id="repeat-options">
              <div className="form-row_CalendarView">
                <label>Repeat Days:</label>
                <div className="repeat-days-container_CalendarView">
                  {["sun", "mon", "tue", "wed", "thu", "fri", "sat"].map(
                    (day) => (
                      <label className="day-pill_CalendarView" key={day}>
                        <input
                          type="checkbox"
                          {...register("repeatDays")}
                          value={day}
                        />
                        <span>{day.charAt(0).toUpperCase()}</span>
                      </label>
                    )
                  )}
                </div>
                {errors.repeatDays && (
                  <p className="error">{errors.repeatDays.message}</p>
                )}
              </div>
              <div className="form-row_CalendarView">
                <label>End Condition:</label>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      value="end-of-month"
                      {...register("endCondition")}
                      defaultChecked
                      style={{ height: 15, width: 15, marginRight: 20 }}
                    />{" "}
                    <label style={{ marginTop: -1 }}>
                      Until the End of Month
                    </label>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      name="end-condition"
                      value="specific-date"
                      {...register("endCondition")}
                      style={{ height: 15, width: 15, marginRight: 20 }}
                    />{" "}
                    <label style={{ marginTop: -1 }}>Specific Date</label>
                    <input
                      type="date"
                      id="specific-date"
                      {...register("specificDate")}
                      style={{ width: 200, marginLeft: 10 }}
                    />
                  </div>
                  {errors.specificDate && (
                    <p className="error">{errors.specificDate.message}</p>
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      {...register("endCondition")}
                      value="number-of-events"
                      style={{ height: 15, width: 15, marginRight: 20 }}
                    />{" "}
                    <label>Number of Events</label>
                    <input
                      type="number"
                      id="number-of-events"
                      {...register("numberOfEvents", {
                        valueAsNumber: true,
                      })}
                      placeholder="Enter number of events"
                      style={{ width: 200, marginLeft: 10 }}
                    />
                  </div>
                  {errors.numberOfEvents && (
                    <p className="error">{errors.numberOfEvents.message}</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Service Location Section */}
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Service Details
          </div>
          <div>
            <div className="form-group_CalendarView">
              <label htmlFor="location">Service Location:</label>

              <select
                id="location"
                name="location"
                {...register("serviceLocationId")}
                // required
              >
                <option value="">-- Select Visit Reason --</option>
                {addressData.map((item) => {
                  return (
                    <option key={item._id} value={item?._id}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
              {errors.serviceLocationId && (
                <p className="error">{errors.serviceLocationId.message}</p>
              )}
            </div>
            <div className="form-group_CalendarView">
              <label htmlFor="payment">Payment Source:</label>
              <input
                type="text"
                id="payment"
                {...register("paymentSource")}
                defaultValue={info?.PaymentSourcesId?.name || ""}
                disabled
              />
              {errors.paymentSource && (
                <p className="error">{errors.paymentSource.message}</p>
              )}
            </div>
          </div>
        </div>
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Patient Intake
          </div>

          <DropDownManuCustomMulti
            label="Required Documents:"
            placeholder="Select option"
       options={[
                  { _id: "Medical History", name: "Medical History" },
                  { _id: "Consent Forms", name: "Consent Forms" },
                  {
                    _id: "Basic Information",
                    name: "Basic Information",
                  },
                  { _id: "Billing Profile", name: "Billing Profile" },
                  { _id: "Identification", name: "Identification" },
                  {
                    _id: "Emergency Contacts",
                    name: "Emergency Contacts",
                  },
                  {
                    _id: "Allergies & Medications",
                    name: "Allergies & Medications",
                  },
                  { _id: "Measures & Vitals", name: "Measures & Vitals" },
                  {
                    _id: "Document Upload",
                    name: "Document Upload",
                  },
                ]}
            name="RequiredDocuments"
            id="_id"
            clearErrors={clearErrors}
            onSelect={HandleselectpatientIntake}
            register={register}
          />
          {errors.patientIntake && (
            <p className="error">{errors.patientIntake.message}</p>
          )}
        </div>
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Provider Task
          </div>

          <DropDownManuCustomMulti
            label="Tasks:"
            placeholder="Select option"
            options={[
              {
                _id: "Review Patient History",
                name: "Review Patient History",
              },
              { _id: "Call Patient", name: "Call Patient" },
              {
                _id: "Update Records",
                name: "Update Records",
              },
              { _id: "Consult with Team", name: "Consult with Team" },
            ]}
            name="Tasks"
            id="_id"
            clearErrors={clearErrors}
            onSelect={Handleselecttask}
            register={register}
          />
          {errors.providerTask && (
            <p className="error">{errors.providerTask.message}</p>
          )}
        </div>
        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Patient Confirmation Methods
          </div>
          <div className="form-row_CalendarView">
            <label>
              <input type="checkbox" {...register("email-confirm")} />
              Send confirmation Email to{" "}
              {info &&
                (isEditingClientEmail ? (
                  <>
                    <input
                      type="text"
                      value={clientEmail}
                      onChange={(e) => setClientEmail(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (!validateEmail(clientEmail)) {
                          setClientEmailError("Invalid email address");
                          return;
                        }
                        setClientEmailError("");
                        setIsEditingClientEmail(false);
                      }}
                    >
                      <i className="fas fa-check" style={{ color: "black" }} />
                    </button>
                    {clientEmailError && (
                      <p className="error">{clientEmailError}</p>
                    )}
                  </>
                ) : (
                  <>
                    {clientEmail}
                    <button
                      type="button"
                      onClick={() => setIsEditingClientEmail(true)}
                    >
                      <i
                        className="fas fa-edit"
                        style={{ color: "black", marginLeft: 10 }}
                      />
                    </button>
                  </>
                ))}
            </label>
            <label>
              <input type="checkbox" {...register("sms-confirm")} />
              Send confirmation SMS to{" "}
              {info &&
                (isEditingClientPhone ? (
                  <>
                    <input
                      type="text"
                      value={clientPhone}
                      onChange={(e) => setClientPhone(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (!validatePhone(clientPhone)) {
                          setClientPhoneError("Phone number must be 10 digits");
                          return;
                        }
                        setClientPhoneError("");
                        setIsEditingClientPhone(false);
                      }}
                    >
                      <i className="fas fa-check" style={{ color: "black" }} />
                    </button>
                    {clientPhoneError && (
                      <p className="error">{clientPhoneError}</p>
                    )}
                  </>
                ) : (
                  <>
                    {clientPhone}
                    <button
                      type="button"
                      onClick={() => setIsEditingClientPhone(true)}
                    >
                      <i
                        className="fas fa-edit"
                        style={{ color: "black", marginLeft: 10 }}
                      />
                    </button>
                  </>
                ))}
            </label>
            <label>
              <input
                type="checkbox"
                id="inapp-confirm"
                name="inapp-confirm"
                {...register("inapp-confirm")}
              />
              {"  "}
              Send push notification to the app
            </label>
          </div>
        </div>

        <div className="section_CalendarView">
          <div
            className="section-header_CalendarView"
            style={{ textAlign: "left" }}
          >
            Provider Confirmation Methods
          </div>
          <div className="form-row_CalendarView">
            <label>
              <input type="checkbox" {...register("provider-email-confirm")} />
              Send confirmation Email to{" "}
              {watch("doctorId") &&
                (isEditingProviderEmail ? (
                  <>
                    <input
                      type="text"
                      value={providerEmail}
                      onChange={(e) => setProviderEmail(e.target.value)}
                    />
                    {providerEmailError && (
                      <p className="error">{providerEmailError}</p>
                    )}
                    <button
                      type="button"
                      onClick={() => {
                        if (!validateEmail(providerEmail)) {
                          setProviderEmailError("Invalid email address");
                          return;
                        }
                        setProviderEmailError("");
                        setIsEditingProviderEmail(false);
                      }}
                    >
                      <i className="fas fa-check" style={{ color: "black" }} />
                    </button>
                  </>
                ) : (
                  <>
                    {providerEmail}
                    <button
                      type="button"
                      onClick={() => setIsEditingProviderEmail(true)}
                    >
                      <i
                        className="fas fa-edit"
                        style={{ color: "black", marginLeft: 10 }}
                      />
                    </button>
                  </>
                ))}
            </label>
            <label>
              <input type="checkbox" {...register("provider-sms-confirm")} />
              Send confirmation SMS to{" "}
              {watch("doctorId") &&
                (isEditingProviderPhone ? (
                  <>
                    <input
                      type="text"
                      value={providerPhone}
                      onChange={(e) => setProviderPhone(e.target.value)}
                    />
                    {providerPhoneError && (
                      <p className="error">{providerPhoneError}</p>
                    )}
                    <button
                      type="button"
                      onClick={() => {
                        if (!validatePhone(providerPhone)) {
                          setProviderPhoneError(
                            "Phone number must be 10 digits"
                          );
                          return;
                        }
                        setProviderPhoneError("");
                        setIsEditingProviderPhone(false);
                      }}
                    >
                      <i className="fas fa-check" style={{ color: "black" }} />
                    </button>
                  </>
                ) : (
                  <>
                    {providerPhone}
                    <button
                      type="button"
                      onClick={() => setIsEditingProviderPhone(true)}
                    >
                      <i
                        className="fas fa-edit"
                        style={{ color: "black", marginLeft: 10 }}
                      />
                    </button>
                  </>
                ))}
            </label>
            <label>
              <input
                type="checkbox"
                id="provider-inapp-confirm"
                name="provider-inapp-confirm"
                {...register("provider-inapp-confirm")}
              />
              {"  "}
              Send push notification to provider app
            </label>
          </div>
        </div>

        <div className="button-container_CalendarView">
          <button type="submit" className="confirm-btn_CalendarView">
            Confirm Appointment
          </button>
          <button
            type="button"
            className="decline-btn_CalendarView"
            onClick={() => setShowAppointmentPanel(false)}
          >
            Decline Appointment
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateAppointment;
